import React from 'react';
import { saveAs } from 'file-saver';
import encoding from 'encoding-japanese';

import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import * as colors from 'material-ui/styles/colors';
import CostMonthCard from './CostMonthCard';
import $ from "jquery";
import _ from "lodash";
import Loading from './Loading';
import Paper from 'material-ui/Paper';
import styles from '../styles'

import YosanLeaner2 from './YosanLeaner2'
import {FieldArray} from 'redux-form'
import Divider from 'material-ui/Divider';
import FormCostContents from './FormCostContents'
import * as commons from '../commons';
import moment from "moment";

const sumMonthCosts = (monthCosts) => {

    const result = !_.isEmpty(monthCosts) && monthCosts
        .map(monthCost => {
            return {
                month: monthCost.month,
                budget: !_.isEmpty(monthCost.data) ? monthCost.data.map(cost => commons.toNumber(cost.budget)).reduce((a, b) => a + b) : 0,
                result: !_.isEmpty(monthCost.data) ? monthCost.data.map(cost => commons.toNumber(cost.result)).reduce((a, b) => a + b) : 0
                // budget: monthCost.data.map(cost => commons.toNumber(cost.budget)).reduce((a, b) => a + b),
                // result: monthCost.data.map(cost => commons.toNumber(cost.result)).reduce((a, b) => a + b)
            }
        });

    return result;

}

const sumNewCosts = (costs) => {
    return {
        budget: !_.isEmpty(costs) ? costs.map(cost => commons.toNumber(cost.budget)).reduce((a, b) => a + b) : 0,
        result: !_.isEmpty(costs) ? costs.map(cost => commons.toNumber(cost.result)).reduce((a, b) => a + b) : 0,
    };
}

const sumAll = (costs) => {
    return {
        budget: !_.isEmpty(costs) ? costs.map(cost => commons.toNumber(cost.budget)).reduce((a, b) => a + b) : 0,
        result: !_.isEmpty(costs) ? costs.map(cost => commons.toNumber(cost.result)).reduce((a, b) => a + b) : 0,
    };
}

function stringToUint(string) {
    var string = btoa(unescape(encodeURIComponent(string))),
        charList = string.split(''),
        uintArray = [];
    for (var i = 0; i < charList.length; i++) {
        uintArray.push(charList[i].charCodeAt(0));
    }
    return new Uint8Array(uintArray);
}

function UTF8toBinary(str) {

    return new Promise(function(resolve, reject) {

        var file = new Blob([str], {'type':'text/plain'});
        var reader = new FileReader();
        reader.onload = function (event) {
            resolve(new Uint8Array(reader.result));
        }

        reader.onerror = function (event) {
            reject('文字列をUint8Arrayに変換できませんでした。');
        }

        reader.readAsArrayBuffer(file);
    });
}


class CostCard extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: false
        }
    }

    componentDidMount() {

        $.ajaxTransport("+binary", function (options, originalOptions, jqXHR) {
            // check for conditions and support for blob / arraybuffer response type
            if (window.FormData && ((options.dataType && (options.dataType == 'binary')) || (options.data && ((window.ArrayBuffer && options.data instanceof ArrayBuffer) || (window.Blob && options.data instanceof Blob))))) {
                return {
                    // create new XMLHttpRequest
                    send: function (headers, callback) {
                        // setup all variables
                        var xhr = new XMLHttpRequest(),
                            url = options.url,
                            type = options.type,
                            async = options.async || true,
                            // blob or arraybuffer. Default is blob
                            dataType = options.responseType || "blob",
                            data = options.data || null,
                            username = options.username || null,
                            password = options.password || null;

                        xhr.addEventListener('load', function () {
                            var data = {};
                            data[options.dataType] = xhr.response;
                            // make callback and send data
                            callback(xhr.status, xhr.statusText, data, xhr.getAllResponseHeaders());
                        });

                        xhr.open(type, url, async, username, password);

                        // setup custom headers
                        for (var i in headers) {
                            xhr.setRequestHeader(i, headers[i]);
                        }

                        xhr.responseType = dataType;
                        xhr.send(data);
                    },
                    abort: function () {
                        jqXHR.abort();
                    }
                };
            }
        });
    }

    handleDownloadEnd() {
        this.setState(Object.assign(this.state, { loading: false }));
    }

    handleDownloadStart() {

        this.setState(Object.assign(this.state, { loading: true }));

    }

    handleCsvDownload(kind, monthCosts, dataSource, start, end, startDate, endDate) {

        return function () {

            const download = (name, data) => {

                const unicodeList = [];
                for (let i = 0; i < data.length; i += 1) {
                    unicodeList.push(data.charCodeAt(i));
                }

                // 変換処理の実施
                const shiftJisCodeList = encoding.convert(unicodeList, 'sjis', 'unicode');
                const uInt8List = new Uint8Array(shiftJisCodeList);

                // csv書き込みの実装
                const writeData = new Blob([uInt8List], { type: 'text/csv' });

                saveAs(writeData, name);

                return;
                //
                // const mimeType = 'text/csv; charset=SHIFT-JIS'
                //
                // // const unicodeArray = [];
                // // for (let i = 0; i < data.length; i++) {
                // //     unicodeArray.push(data.charCodeAt(i));
                // // }
                // // const sjisData = encoding.convert(unicodeArray, {
                // //     from: 'SJIS',
                // //     to: 'UTF-8',
                // //     type: 'string',
                // // });
                // //
                // // console.log(sjisData)
                //
                // let blob = new Blob([data], {type: mimeType})
                // let downloadUrl = URL.createObjectURL(blob);
                //
                // let a = document.createElement("a");
                // a.href = downloadUrl
                // a.download = name
                // // a.target = '_blank'
                //
                // if (window.navigator.msSaveBlob) {
                //     // for IE
                //     window.navigator.msSaveBlob(blob, name)
                // } else if (window.URL && window.URL.createObjectURL) {
                //     // for Firefox
                //     a.href = window.URL.createObjectURL(blob);
                //     document.body.appendChild(a);
                //     a.click();
                //     document.body.removeChild(a);
                // } else if (window.webkitURL && window.webkitURL.createObject) {
                //     // for Chrome
                //     a.href = window.webkitURL.createObjectURL(blob);
                //     a.click();
                // } else {
                //     // for Safari
                //     window.open('data:' + mimeType + ';base64,' + window.Base64.encode(data), '_blank');
                // }

            }

            const name = kind + '.csv'

            if (kind == "労務費") {

                if (_.isEmpty(monthCosts) || _.isEmpty(monthCosts[0].data)) {
                    download(name, "no data")
                    return
                }

                start()

                const historyYearMonth = moment().format('YYYY/MM')
                const yosanId = monthCosts[0].data[0].yosanId

                let termQuery = '';
                if (startDate) {
                    termQuery += '&startDate=' + startDate
                }
                if (endDate) {
                    termQuery += '&endDate=' + endDate
                }

                $.ajax({
                    url: `/bg/yosan/roumuCsv?id=${yosanId}&historyMonth=${historyYearMonth}${termQuery}`,
                    contentType: 'application/json',
                    timeout: 1000 * 100,
                    error: function () {
                    },
                    success: function (data) {

                        end()

                        download(name, data.result);

                    },
                    type: 'GET'
                });

            } else if (kind == "労務費（外部サイト連携）") {

                if (_.isEmpty(monthCosts) || _.isEmpty(monthCosts[0].data)) {
                    download(name, "no data")
                    return
                }

                start()

                const historyYearMonth = moment().format('YYYY/MM')
                const yosanId = monthCosts[0].data[0].yosanId

                let termQuery = '';
                if (startDate) {
                    termQuery += '&startDate=' + startDate
                }
                if (endDate) {
                    termQuery += '&endDate=' + endDate
                }

                $.ajax({
                    url: `/bg/yosan/xronosRoumuCsv?id=${yosanId}&historyMonth=${historyYearMonth}${termQuery}`,
                    contentType: 'application/json',
                    timeout: 1000 * 100,
                    error: function () {
                    },
                    success: function (data) {

                        end()

                        download(name, data.result);

                    },
                    type: 'GET'
                });


            } else {

                const header = '年月,項目,実績,予算,備考'
                let dataArray = []
                monthCosts.forEach(monthCost => {
                    const monthCostArray = monthCost.data.map(x => {
                        return monthCost.month
                            + ',' + this.getCostName(x.costId, x.costName, dataSource)
                            + ',' + (x.result ? x.result : 0)
                            + ',' + (x.budget ? x.budget : 0)
                            + ',' + x.comment
                    })
                    dataArray = dataArray.concat(monthCostArray)
                })
                const data = dataArray.join("\n")

                download(name, header + "\n" + data)

            }

        }.bind(this)

    }

    getCostName(costId, costName, dataSource) {

        if (costName) {
            return costName
        }

        for (let i = 0; i < dataSource.length; i++) {
            const element = dataSource[i]
            if (element.id == costId) {
                return element.name
            }
        }

        return ""

    }

    render() {

        const {
            kind,
            monthCosts,
            name,
            dataSourceConfig,
            dataSourceType,
            dataSource,
            resultDisable,
            status,
            dispatch,
            newCosts,
            newCostName,
            isNew,
            startDate,
            endDate
        } = this.props

        const newCostSumData = sumNewCosts(newCosts)
        const monthCostsSumDatas = sumMonthCosts(monthCosts)

        let allBudget = 0;
        let allResult = 0;

        if (newCostSumData) {
            allBudget = newCostSumData.budget;
            allResult = newCostSumData.result;
        }
        if (!kind.startsWith("労務費") && monthCostsSumDatas) {
            allBudget += monthCostsSumDatas.map(x => x.budget).reduce((a, b) => a + b)
            allResult += monthCostsSumDatas.map(x => x.result).reduce((a, b) => a + b)
        }

        return (
            <div>
                <Card>
                    <CardHeader
                        title={kind}
                        subtitle={(
                            <div>
                                <span style={{color: colors.grey600, fontSize: 11}}>
                                    合計 (実)
                                    <span style={{marginLeft: 10, fontSize: 23}}>
                                    {commons.dispMoney(allResult)}
                                    </span>
                                </span>
                                <span style={{marginLeft: 20, color: colors.grey600, fontSize: 11}}>
                                    合計 (予)
                                    <span style={{marginLeft: 10, fontSize: 23}}>
                                    {commons.dispMoney(allBudget)}
                                    </span>
                                </span>
                            </div>
                        )}
                        // subtitle={`合計（実）：${commons.dispMoney(allResult)}、  合計（予）：${commons.dispMoney(allBudget)} `}
                        subtitleStyle={{marginTop: 10}}

                        actAsExpander={true}
                        showExpandableButton={true}
                        titleStyle={{color: colors.grey700, fontSize: 20}}
                    >
                    </CardHeader>
                    <CardActions style={{ width: '100%', textAlign: 'right' }}>
                        <FlatButton label="ダウンロード" onClick={this.handleCsvDownload(
                            kind,
                            monthCosts,
                            dataSource,
                            this.handleDownloadStart.bind(this),
                            this.handleDownloadEnd.bind(this),
                            startDate,
                            endDate
                        ).bind(this)}/>
                    </CardActions>
                    <CardText expandable={true} style={{marginBottom: 10}}>
                        {
                            (monthCosts && monthCosts.map((row, rowIndex) => {

                                const matchSumData = monthCostsSumDatas.filter(x => x.month == row.month)
                                let monthResult = 0
                                let monthBudget = 0
                                if (!_.isEmpty(matchSumData)) {
                                    const data = matchSumData.shift()
                                    monthResult = data.result
                                    monthBudget = data.budget
                                }

                                return (
                                    <div key={rowIndex}>
                                        <CostMonthCard
                                            result={monthResult}
                                            budget={monthBudget}
                                            parentIndex={rowIndex}
                                            name={name}
                                            kind={kind}
                                            month={row.month}
                                            costs={row.data}
                                            dataSource={dataSource}
                                            dataSourceType={dataSourceType}
                                            status={status}
                                            dispatch={dispatch}
                                            resuleDisable
                                        />
                                        {/*<div style={this.costStyle(1, parent.month, costOpens)}>*/}
                                        {/*{rows}*/}
                                        {/*</div>*/}
                                    </div>
                                )
                            }))
                        }

                        <div className="row" style={{marginTop: 30}}>
                            <div className="col">
                                <Paper style={styles.yosanContents}>

                                    <FieldArray kind={kind} name={newCostName} org={newCosts} component={FormCostContents}
                                                dataSourceType={dataSourceType} dataSource={dataSource} status={status} isNew={isNew}/>

                                    <YosanLeaner2 budget={allBudget} result={allResult}/>

                                </Paper>
                            </div>
                        </div>

                    </CardText>
                </Card>
                <Loading open={this.props.loading}/>
            </div>
        )
    }
}

export default CostCard;



// WEBPACK FOOTER //
// ./src/components/CostCard.js